import Call from './Call';
export default Call;


// WEBPACK FOOTER //
// /src/components/call/index.js